"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createRollbarMiddleware;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _getLogLevel = _interopRequireDefault(require("./helpers/get-log-level"));

var _logLevel = _interopRequireDefault(require("./constants/log-level"));

var _getOptions2 = _interopRequireDefault(require("./helpers/get-options"));

var _getLogMessage = _interopRequireDefault(require("./helpers/get-log-message"));

var _testWhitelistedErrors = _interopRequireDefault(require("./helpers/test-whitelisted-errors"));

var _isActionError = _interopRequireDefault(require("./helpers/is-action-error"));

var _getException = _interopRequireDefault(require("./helpers/get-exception"));

var _rollbar = require("./rollbar");

var _excluded = ["message"];

function logMessage(_ref) {
  var rollbar = _ref.rollbar,
      level = _ref.level,
      message = _ref.message,
      extra = _ref.extra,
      exception = _ref.exception;
  var params = [message, extra];

  if (exception) {
    params.push(exception);
  }
  /*
   * rollbar.log is available, however it requires a separate line to be executed:
   * `Rollbar.configure({logLevel: "warning"});` which may leave the global state with an
   * unexpected `logLevel`.
   */


  switch (level) {
    case _logLevel.default.DEBUG:
      rollbar.debug.apply(rollbar, params);
      break;

    case _logLevel.default.INFO:
      rollbar.info.apply(rollbar, params);
      break;

    case _logLevel.default.WARNING:
      rollbar.warning.apply(rollbar, params);
      break;

    case _logLevel.default.ERROR:
      rollbar.error.apply(rollbar, params);
      break;

    case _logLevel.default.CRITICAL:
      rollbar.critical.apply(rollbar, params);
      break;

    default:
      rollbar.info.apply(rollbar, params);
      break;
  }
}
/**
 * Redux middleware for reporting Flow API errors to Rollbar.
 *
 * @param {Object} options
 * @param {Object} options.rollbar - An instance of the Rollbar class from the 'rollbar' module
 */


function createRollbarMiddleware() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$rollbar = _ref2.rollbar,
      rollbar = _ref2$rollbar === void 0 ? undefined : _ref2$rollbar,
      _ref2$extendOptionsFn = _ref2.extendOptionsFn,
      extendOptionsFn = _ref2$extendOptionsFn === void 0 ? undefined : _ref2$extendOptionsFn;

  return function (store) {
    return function (next) {
      return function (action) {
        try {
          (0, _rollbar.setStore)(store);
          (0, _rollbar.setRollbar)(rollbar);

          if ((0, _isActionError.default)(action)) {
            var message = (0, _getLogMessage.default)(action);
            var level = (0, _getLogLevel.default)(action);
            var exception = (0, _getException.default)(action);

            var _getOptions = (0, _getOptions2.default)(action, store, extendOptionsFn),
                discardedMessage = _getOptions.message,
                extra = (0, _objectWithoutProperties2.default)(_getOptions, _excluded); // Test for any unhandled error codes and log them as well.


            try {
              (0, _testWhitelistedErrors.default)(action);
            } catch (error) {
              rollbar.debug(error);
            }

            logMessage({
              rollbar: rollbar,
              level: level,
              message: message,
              extra: extra,
              exception: exception
            });
          }
        } catch (error) {
          rollbar.error('Failed to send rollbar request', error);
        }

        return next(action);
      };
    };
  };
}